import { useCallback, useMemo, useState } from "react";

import * as QueryRepository from "../repository";

import type { SearchTypeForSearchSalesMastList } from "../constants";
import type { QueryData } from "../type";

export type OnSearchSalesMastListProps = {
	from: string;
	to: string;
};

type Result = {
	queryData: QueryData;

	searchType: SearchTypeForSearchSalesMastList;
	onSetSearchType: (type: SearchTypeForSearchSalesMastList) => void;

	// 予約の検索
	onSearchSalesMastList: (props: OnSearchSalesMastListProps) => void;
};

type Props = {
	hotelID: string;
};

export const useSearchSalesMastList = ({ hotelID }: Props): Result => {
	const [searchType, setSearchType] = useState<SearchTypeForSearchSalesMastList>("all");
	const onSetSearchType = useCallback((type: SearchTypeForSearchSalesMastList) => {
		setSearchType(type);
	}, []);

	const [queryVariables, setQueryVariables] = useState<
		{ hotelID: string; startDate: string; endDate: string } | undefined
	>(undefined);
	/**
	 * 日付の範囲検索
	 */
	const { data } = QueryRepository.useSalesMastListByStartAndEndDate({ queryVariables });
	const queryData = useMemo(() => (data ? data.salesMastList.list : []), [data]);

	/**
	 * 収支リストの検索
	 */
	const onSearchSalesMastList = useCallback(
		({ from, to }: OnSearchSalesMastListProps) => {
			setQueryVariables({ hotelID, startDate: from, endDate: to });
		},
		[hotelID],
	);

	return {
		queryData,
		searchType,
		onSetSearchType,
		//
		// 収支リストの検索
		onSearchSalesMastList,
	};
};
